import fetch from '../../utils/fetch'

export function getCouponKey(params) {
    return fetch({
        url: '/api/bussinessCoupon/getOneCouponInfoConponKey',
        method: 'GET',
        params
    })
}
